import { useEffect, useState } from "react";
import { useGetRetentionPoliciesQuery } from "../../../../store/api/admin/adminApiSlice";
import { IRetentionPolicyResponse } from "../../../../store/api/devices/types";


export const useRetentionData = () => {

    const [values, setValues] = useState<IRetentionPolicyResponse>({
        CM_MAX_SIZE: '',
        PM_MAX_SIZE: '',
        CPER_MAX_SIZE: '',
        SN_DB_MAX_SIZE: '',
        DEBUGLOGS_MAX_SIZE: '',
        COREFILE_MAX_SIZE: '',
        DB_BACKUP_MAX_SIZE: ''
      });

    const { data, isLoading, error } = useGetRetentionPoliciesQuery();

  useEffect(() => {
    if (data) {
      setValues(data);
    }
  }, [data]);

  return {
    values, 
    setValues,
    isLoading, 
    error
  }

}